var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 634,
    height: 623,
    viewBox: "0 0 634 623",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.944 1.69611C118.081 -13.2494 46.6923 74.0861 38.4335 125.793C26.5418 200.246 -17.3133 207.692 7.46309 386.392C38.4335 609.767 63.2099 603.562 360.526 622.176C598.379 637.068 641.325 446.374 633.066 349.165C620.678 156.815 620.678 20.305 341.944 1.69611Z",
    fill: "#FFFF01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape1.9fd6addae36b78b5a3fd074068950555.svg";
export { ForwardRef as ReactComponent };